var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{class:_vm.breadcrumbsClass},_vm._l((_vm.breadcrumbs),function(breadcrumb,index){return _c('li',{key:index,staticClass:"breadcrumbs__breadcrumb"},[(breadcrumb.route)?_c('router-link',{attrs:{"to":breadcrumb.route}},[_vm._v(" "+_vm._s(breadcrumb.label)+" ")]):_c('span',[_vm._v(" "+_vm._s(breadcrumb.label)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }